<template>
  <v-container fluid fill-height>
    <v-layout align-space-around justify-start fill-height column>
        <v-flex sm12>
            <v-toolbar
            color="#eee"
            class="elevation-0 secondary--text mb-4"
            style="background: transparent" >
                <v-toolbar-title>Fale com o Cliente</v-toolbar-title>
            </v-toolbar>
        </v-flex>
        <card-envio-de-email
          @success="snackbarSucess"
          @error="snackbarError"
        />
        <v-snackbar
          v-model="snackbar.ativo"
          :color="snackbar.color"
          :timeout="4000"
          :vertical="true"
        >
          {{snackbar.text}}
        <v-spacer></v-spacer>
        <v-btn @click="snackbar.active = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import CardEnvioDeEmail from '@/components/CardEnvioDeEmail.vue'

export default {
  components: { CardEnvioDeEmail },
  data: () => ({
    snackbar: {
      ativo: false,
      color: 'info',
      text: ''
    }
  }),
  methods: {
    snackbarSucess (texto) {
      this.snackbar.text = texto
      this.snackbar.color = 'primary'
      this.snackbar.ativo = true
    },
    snackbarError (texto) {
      this.snackbar.text = texto
      this.snackbar.color = 'red'
      this.snackbar.ativo = true
    }
  }
}
</script>
